import * as React from 'react';
export const scalapaySvg = React.forwardRef(function scalapaySvgInner(
  props,
  ref,
) {
  return /*#__PURE__*/ React.createElement(
    'svg',
    {
      ...props,
      ref: ref,
    },
    /*#__PURE__*/ React.createElement('path', {
      fill: '#F7CBCF',
      d: 'M0 0h32v32H0z',
    }),
    /*#__PURE__*/ React.createElement('path', {
      d: 'M16.077 26.192c-.373 0-.685-.12-.934-.36-.094-.09-.171-.18-.265-.285-3.458-3.796-6.9-7.608-10.358-11.42-.078-.09-.171-.18-.25-.285-.373-.495-.357-1.095.032-1.56.078-.09.171-.18.265-.286 1.542-1.53 3.084-3.06 4.61-4.592.094-.09.172-.18.28-.27a1.329 1.329 0 0 1 1.745 0c.125.105.25.225.358.345 1.075 1.08 2.165 2.146 3.256 3.227.124.12.233.24.358.345.171.15.358.255.576.3.436.105.826 0 1.153-.255a3.83 3.83 0 0 0 .358-.345L20.44 7.6c.124-.12.233-.24.358-.346a1.34 1.34 0 0 1 1.791 0c.093.075.187.18.28.27l4.58 4.547c.062.06.124.136.187.196.451.48.498 1.155.062 1.68-.078.075-.14.165-.218.24-3.396 3.737-6.776 7.489-10.171 11.225-.11.12-.218.24-.343.36-.218.24-.53.36-.857.39l-.03.03Z',
      fill: '#000',
    }),
  );
});
scalapaySvg.defaultProps = {
  width: '32',
  height: '32',
  viewBox: '0 0 32 32',
  fill: 'none',
  xmlns: 'http://www.w3.org/2000/svg',
};
export var scalapay = {
  category: 'brand',
  colorable: false,
  name: 'scalapay',
  svg: scalapaySvg,
};
